import { render, staticRenderFns } from "./productNameSpecQuery.vue?vue&type=template&id=f2f6bee8"
import script from "./productNameSpecQuery.vue?vue&type=script&lang=js"
export * from "./productNameSpecQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports